var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "input",
    attrs: {
      type: "file",
      accept: _vm.question.accept,
      multiple: _vm.question.multiple,
      required: _vm.question.required
    },
    domProps: { value: _vm.value },
    on: {
      keyup: [
        function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.onEnter.apply(null, arguments)
        },
        function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.onEnter.apply(null, arguments)
        }
      ],
      focus: _vm.setFocus,
      blur: _vm.unsetFocus,
      change: _vm.onChange
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }